module.exports = __webpack_public_path__ + "img/puzzle2-400.4e3e08c5.png";